"use client";

// src/primitives/thread/ThreadEmpty.tsx
import { useThread } from "../../context/index.js";
var ThreadPrimitiveEmpty = ({
  children
}) => {
  const empty = useThread((u) => u.messages.length === 0);
  return empty ? children : null;
};
ThreadPrimitiveEmpty.displayName = "ThreadPrimitive.Empty";
export {
  ThreadPrimitiveEmpty
};
//# sourceMappingURL=ThreadEmpty.js.map